import React from 'react'

import WhatsApp from '@images/whatsapp.png'

export default (props) =>
  <img {...props} src={WhatsApp}></img>
